import React from 'react';
import PropTypes from 'prop-types';

import PrismSort from '../../sort/prismSort';
import initPrismPageSizePicker from '../../PageSizePicker/PrismPageSizePicker.jsx';

import {
    SORT_COLUMN_PROP_TYPES,
    SORT_DIRECTION_PROP_TYPES
} from '../../sort/constants';

const initComponent = (flex = window.flex) => {

    const PrismPageSizePicker = initPrismPageSizePicker(flex);

    class PrismGridControls extends React.PureComponent {
        static propTypes = {
            hidePageOptions: PropTypes.bool,
            pageSize: PropTypes.number.isRequired,
            perPageOptions: PropTypes.arrayOf(PropTypes.number),
            sortableColumns: PropTypes.arrayOf(SORT_COLUMN_PROP_TYPES),
            sortBy: PropTypes.string,
            sortDirection: SORT_DIRECTION_PROP_TYPES,
            paigerLabel: PropTypes.string,
            onSortSelect: PropTypes.func.isRequired,
            onChangePageSize: PropTypes.func.isRequired
        };

        renderPageSizeControl = ({
            pageSize,
            paigerLabel,
            perPageOptions,
            onChangePageSize
        }) => (
            <PrismPageSizePicker
                perPageOptions={perPageOptions}
                pageSize={pageSize}
                paigerLabel={paigerLabel}
                onChangePageSize={onChangePageSize}
            />
        )

        renderSortControl = ({
            sortableColumns,
            sortBy,
            sortDirection,
            onSortSelect
        }) => (
            <PrismSort
                sortColumns={sortableColumns}
                sortBy={sortBy}
                sortDirection={sortDirection}
                onSortSelect={onSortSelect}
            />
        )

        render() {
            const {
                hidePageOptions,
                sortableColumns
            } = this.props

            return (
                <div className="prism-grid__controls">
                    <div className="prism-grid__controls_control-container">
                        {!hidePageOptions && this.renderPageSizeControl(this.props)}
                    </div>
                    <div className="prism-grid__controls_control-container">
                        {!_.isEmpty(sortableColumns) && this.renderSortControl(this.props)}
                    </div>
                </div>
            );
        }
    }

    return PrismGridControls
}

export default initComponent;
